/** A published product as returned by the storefront API, with the joined
 *  category / collection / type names and the full image gallery. */
export interface Product {
  id: number;
  name: string;
  slug: string;
  description: string;
  short_description: string;
  category_id: number | null;
  product_type_id: number | null;
  collection_id: number | null;
  price: number;
  discount: number;
  stock: number;
  featured: boolean;
  trending: boolean;
  new_arrival: boolean;
  anti_tarnish: boolean;
  material: string;
  color: string;
  weight: string;
  availability: 'in_stock' | 'out_of_stock';
  thumbnail_url: string;
  status: 'published' | 'draft';
  seo_title: string;
  seo_description: string;
  created_at: string;
  category_name: string | null;
  category_slug: string | null;
  collection_name: string | null;
  collection_slug: string | null;
  product_type_name: string | null;
  product_type_slug: string | null;
  images: string[];
}

/** Payload sent when creating or updating a product from the dashboard. */
export interface ProductInput {
  name: string;
  slug: string;
  description: string;
  short_description: string;
  category_id: number | null;
  product_type_id: number | null;
  collection_id: number | null;
  price: number;
  discount: number;
  stock: number;
  featured: boolean;
  trending: boolean;
  new_arrival: boolean;
  anti_tarnish: boolean;
  material: string;
  color: string;
  weight: string;
  availability: string;
  thumbnail_url: string;
  status: string;
  seo_title: string;
  seo_description: string;
  images: string[];
}

export interface CartItem {
  id: number;
  name: string;
  slug: string;
  price: number;
  discount: number;
  thumbnail_url: string;
  quantity: number;
}

export interface WishlistItem {
  id: number;
  name: string;
  slug: string;
  price: number;
  discount: number;
  thumbnail_url: string;
}

/** Effective price after applying any percentage discount. */
export function salePrice(price: number, discount: number): number {
  if (!discount || discount <= 0) return price;
  return Math.round(price * (1 - discount / 100));
}
